<template>
  <div class="add-project-manager__form">
    <h3>Сменить руководителя проекта</h3>
    <a-form
      class="form"
      :model="model"
      :rules="rules"
      @finish="onFinish"
      @validate="errors.onValidate"
    >
      <a-form-item name="projectManager">
        <a-select
          id="userId"
          placeholder="Выберите сотрудника"
          v-model:value="model.userId"
          :options="model.usersList"
          optionFilterProp="label"
          @search="searchUser"
          showSearch
        />
      </a-form-item>

      <a-form-item class="form__button">
        <c-button-primary html-type="submit" :loading="isLoading">
          Сохранить
        </c-button-primary>
      </a-form-item>
    </a-form>
  </div>
</template>

<script setup>
  import { reactive, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import ErrorsHandler from '@/components/form/errors-handler';
  import CButtonPrimary from '@/components/UI/CButtonPrimary';
  import { debounce } from 'lodash-es';
  import { useRoute } from 'vue-router';

  const api = useApi();
  const route = useRoute();
  const emit = defineEmits(['close', 'update']);

  const isLoading = ref(false);
  const model = reactive({
    usersList: [],
    userId: null,
  });

  const rules = {
    userId: [
      {
        type: 'string',
        required: true,
        message: 'Необходимо выбрать исполнителя',
        trigger: 'change',
      },
    ],
  };

  const errors = new ErrorsHandler({
    userId: '',
  });

  const usersToList = (users) => {
    return users.map((user) => ({ value: user.id, label: user.fullName }));
  };

  const searchUser = debounce(async (value) => {
    try {
      const query = new URLSearchParams();

      if ('' !== value) {
        query.set('name', value);
      }

      const response = await api.user.leaders(query);
      model.usersList = usersToList(response.user.items);
    } catch (error) {
      console.log(error);
    }
  }, 500);

  const onFinish = async () => {
    try {
      isLoading.value = true;
      await api.administratorPage.changeProjectLeader(route.params.id,{
        leaderId: model.userId,
      });

      emit('close');
      emit('update');
    } catch (error) {
      console.log(error);
    } finally {
      isLoading.value = false;
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .add-project-manager__form {
    padding: 112px 17px 0 17px;

    h3 {
      font: 700 18px/26px 'Nunito Sans';
    }

    .ant-form-item {
      margin-bottom: 14px;
    }

    .form__button {
      text-align: right;
    }
  }
</style>
